import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSelectedSoldTos, updatePrimaryAccount, clearSelectedInvoices } from "../../actions/InvoiceActions";
import { getSelectedPrimaryAccount } from "../invoice/Selectors";
import { ACCOUNT_PAYER_ALL } from "../../constants/ApplicationConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import { isStringNotEmptyOrNull } from "../../utils";
export class NavAccountSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasMorethanOneHeaderItems: true,
        };
        this.onHeaderDropdownSelected = this.onHeaderDropdownSelected.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
        this.dropdownRef = React.createRef(null);
    }
   
    componentDidMount() {
        this.props.dispatch(setSelectedSoldTos(this.props.secondaryAccounts.map(account => account.PrimaryAcct)));
    }

    onHeaderDropdownSelected(i) {
        if (this.props.selectedPrimaryAccountIndex !== i) {
            clearSelectedInvoices(this.props.dispatch);
            updatePrimaryAccount(this.props.dispatch, i, this.props.accountType !== ACCOUNT_PAYER_ALL);
    }
    this.dropdownRef.current.click();
    }

    createSelectItems() {

        const items = [];

        const { primaryAccounts, selectedPrimaryAccountIndex } = this.props;

        // Validate selectedPrimaryAccountIndex to ensure it is within bounds

        const validSelectedIndex = selectedPrimaryAccountIndex >= 0 && selectedPrimaryAccountIndex < primaryAccounts.length

            ? selectedPrimaryAccountIndex

            : 0; // Default to the first item if out of bounds

        for (let i = 0; i < primaryAccounts.length; i++) {

            const headerItem = primaryAccounts[i];

            let activeClass = 'dropdown-item';

            // Set active class for the valid selected index

            if (validSelectedIndex === i) {
                activeClass = 'dropdown-item headerDropdownItemColor';
            }

            items.push(
                <a

                    className={activeClass}

                    key={headerItem.PrimaryAcct}

                    onClick={() => this.onHeaderDropdownSelected(i)}
                >
                    <div>{headerItem.Name}</div>
                    <div className={"account-subheader"}>{headerItem.PrimaryAcct}</div>
                </a>

            );

        }

        return items;
    }

    render() {
        let name;
        let overflowClass;
        const { selectedPrimaryAccount, primaryAccounts } = this.props;

        if (primaryAccounts != null) {
            overflowClass = primaryAccounts.length > 10 ? "header-dropdown-overflow" : "";
        }
        
        if (selectedPrimaryAccount != null) {
            name = this.props.selectedPrimaryAccount.Name;
            if (
                this.props.selectedPrimaryAccount.CompanyCode.startsWith("JP") &&
                isStringNotEmptyOrNull(this.props.selectedPrimaryAccount.name_2)
            ) {
                name = this.props.selectedPrimaryAccount.name_2;
            }

        }

        return (
            <li className="nav-item">
                <div
                    className="dropdown customSelect mouseHover"
                    style={{ marginTop: "-5px" }}
                >
                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-basic"
                            className={"btn dropdown-toggle dropbtn truncate"}
                            ref={this.dropdownRef }
                        >
                            <div className={"d-flex flex-row"}>
                                <span>
                                    <div>
                                        <div className="truncate">
                                            {this.props.selectedPrimaryAccount && name}
                                        </div>
                                        <div className={"account-subheader"}>
                                            {this.props.selectedPrimaryAccount &&
                                                this.props.selectedPrimaryAccount.PrimaryAcct}
                                        </div>
                                    </div>
                                </span>
                                {this.props.primaryAccounts.length > 1 && (
                                    <span className="select-arrow">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                )}
                            </div>
                        </Dropdown.Toggle>

                        {this.props.primaryAccounts.length > 1 && (
                            <Dropdown.Menu className={overflowClass}>
                                {this.createSelectItems()}
                            </Dropdown.Menu>
                        )}
                    </Dropdown>
                </div>
            </li>
        );
        //return <li className="nav-item">
        //    <div className="dropdown customSelect">
        //        <button className="btn dropdown-toggle dropbtn truncate" type="button" id="dropdownMenuButton"
        //            data-toggle="dropdown"
        //            data-target="#account-dropdown"
        //            aria-haspopup="true" aria-expanded="false">
        //            <div className={'d-flex flex-row'}>
        //                <div>
        //                    <div
        //                        className='truncate'>{this.props.selectedPrimaryAccount && (this.props.selectedPrimaryAccount.Name)}</div>
        //                    <div
        //                        className={'account-subheader'}>{this.props.selectedPrimaryAccount && (this.props.selectedPrimaryAccount.PrimaryAcct)}</div>
        //                </div>
        //                <span className="select-arrow">
        //                    <FontAwesomeIcon icon={faChevronDown} />
        //                </span>
        //            </div>
        //        </button>
        //        {this.state.hasMorethanOneHeaderItems ?
        //            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" id={"account-dropdown"}>
        //                {this.createSelectItems()}
        //            </div>
        //            : ''
        //        }
        //    </div>
        //</li>
    }

}

export default connect((state, props) => {
    return {
        selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
        selectedPrimaryAccountIndex: state.user_options.selectedPrimaryAccountIndex,
        primaryAccounts: state.user_options.primaryAccounts,
        secondaryAccounts: state.user_options.secondaryAccounts,
        accountType: state.user_options.accountType,
    }
})(NavAccountSelect);